import { PROGRESS_STATUSES } from './socket-events';

export const progressColorStatus = {
  [PROGRESS_STATUSES.IN_PROGRESS]: 'var(--darkTurkiz)',
  [PROGRESS_STATUSES.FAILURE]: 'var(--severityRed)',
  [PROGRESS_STATUSES.ABORTED]: 'var(--severityRed)',
  [PROGRESS_STATUSES.SUCCESS]: 'var(--mainGreen)',
  [PROGRESS_STATUSES.TIME_LIMIT]: 'var(--darkTurkiz)'
};

export const progressSnackbarColorStatus = {
  [PROGRESS_STATUSES.IN_PROGRESS]: 'var(--oxfordBlue)',
  [PROGRESS_STATUSES.FAILURE]: 'var(--cgRed)',
  [PROGRESS_STATUSES.ABORTED]: 'var(--cgRed)',
  [PROGRESS_STATUSES.SUCCESS]: 'green',
  [PROGRESS_STATUSES.TIME_LIMIT]: 'var(--oxfordBlue)'
};

export const statusToTextMap = {
  [PROGRESS_STATUSES.IN_PROGRESS]: 'In progress...',
  [PROGRESS_STATUSES.TIME_LIMIT]: 'In progress...',
  [PROGRESS_STATUSES.FAILURE]: 'Error',
  [PROGRESS_STATUSES.SUCCESS]: 'Success',
  [PROGRESS_STATUSES.ABORTED]: 'Aborted'
};
export const statusToIconMap = {
  [PROGRESS_STATUSES.IN_PROGRESS]: 'muiPlayCircleOutline',
  [PROGRESS_STATUSES.TIME_LIMIT]: 'muiPlayCircleOutline',
  [PROGRESS_STATUSES.FAILURE]: 'muErrorOutline',
  [PROGRESS_STATUSES.ABORTED]: 'muErrorOutline',
  [PROGRESS_STATUSES.SUCCESS]: 'muCheckCircleOutlined'
};
